module.exports = __webpack_public_path__ + "img/max-file-subtract--zip.2d93ef6b.svg";